import BarRoot, { Props } from './Bar'

export default function Bar(props: Props) {
  return <BarRoot {...props} />
}
